export default __webpack_public_path__ + "static/media/xmas_2024.2427a03d.webp";